// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"46f0c9d2","182":"71742b62","484":"24d0bb20","508":"12ff322e","559":"334fe29d","869":"bc83ca25","974":"254a7b36"}[chunkId] + ".chunk.js";
};